import React, { useEffect, useRef } from 'react';
import FolderOutlined from '@mui/icons-material/FolderOutlined';
import RocketLaunchOutlined from '@mui/icons-material/RocketLaunchOutlined';
import EventOutlined from '@mui/icons-material/EventOutlined';
import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import HandymanOutlined from '@mui/icons-material/HandymanOutlined';
import LocationCityOutlined from '@mui/icons-material/LocationCityOutlined';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import MicOutlined from '@mui/icons-material/MicOutlined';
import MailOutlined from '@mui/icons-material/MailOutlined';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';

const SECTION_LABEL_STYLE = {
  fontFamily: "'Roboto', sans-serif",
  fontWeight: 500,
  fontSize: '11px',
  color: '#565656',
  letterSpacing: '2px',
  padding: '8px 16px 4px 16px',
};

const DIVIDER_STYLE = {
  borderTop: '1px solid #3a3a3a',
  margin: '8px 0',
};

const SECTIONS = [
  {
    label: 'WORKSPACE',
    items: [
      { key: 'project',  label: 'Project',  Icon: FolderOutlined },
      { key: 'proposal', label: 'Proposal', Icon: RocketLaunchOutlined },
      { key: 'event',    label: 'Event',    Icon: EventOutlined },
    ],
  },
  {
    label: 'DATABASE',
    items: [
      { key: 'client',    label: 'Client',    Icon: BusinessOutlined },
      { key: 'vendor',    label: 'Vendor',    Icon: HandymanOutlined },
      { key: 'venue',     label: 'Venue',     Icon: LocationCityOutlined },
      { key: 'personnel', label: 'Personnel', Icon: PersonOutlined },
      { key: 'talent',    label: 'Talent',    Icon: MicOutlined },
    ],
  },
  {
    label: 'PEOPLE',
    items: [
      { key: 'invite', label: 'Invite User', Icon: MailOutlined },
      { key: 'team',   label: 'Team',        Icon: GroupsOutlined },
    ],
  },
];

function MenuItem({ Icon, label, onClick }) {
  const [hovered, setHovered] = React.useState(false);
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 16px',
        color: hovered ? '#39FF14' : '#F5F5F5',
        fontFamily: "'Roboto', sans-serif",
        fontWeight: 500,
        fontSize: '14px',
        cursor: 'pointer',
        backgroundColor: hovered ? 'rgba(57, 255, 20, 0.06)' : 'transparent',
        transition: 'all 0.15s ease',
      }}
    >
      <span style={{ width: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Icon style={{ fontSize: 18, color: 'inherit' }} />
      </span>
      {label}
    </div>
  );
}

export default function CreateMenu({ isOpen, onClose, onSelect }) {
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        onClose();
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      ref={ref}
      style={{
        position: 'absolute',
        top: '44px',
        left: 0,
        backgroundColor: '#2a2a2a',
        border: '1px solid #3a3a3a',
        borderRadius: '8px',
        boxShadow: '0 16px 48px rgba(0,0,0,0.6), 0 0 40px rgba(57, 255, 20, 0.06)',
        zIndex: 1001,
        minWidth: '200px',
        padding: '8px 0',
      }}
    >
      {SECTIONS.map((section, si) => (
        <React.Fragment key={section.label}>
          {si > 0 && <div style={DIVIDER_STYLE} />}
          <div style={SECTION_LABEL_STYLE}>{section.label}</div>
          {section.items.map((item) => (
            <MenuItem
              key={item.key}
              Icon={item.Icon}
              label={item.label}
              onClick={() => onSelect(item.key)}
            />
          ))}
        </React.Fragment>
      ))}
    </div>
  );
}
